import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import Translate from "../../utils/Translate";
import { useState } from "react";
import ButtonWithSpinner from "../ButtonWithSpinner";

const InactivateActorPermitDialog = ({actorPermit, onInactivateClick, onClose}) => {
    const [reason, setReason] = useState();
    return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="xs">
        <DialogTitle>{Translate.get("InactivatePermit")}</DialogTitle>
        <DialogContent>
            <TextField autoFocus label={Translate.get("Reason")}
                fullWidth
                multiline={true}
                value={reason}
                onChange={(evt) => setReason(evt.target.value)} 
                slotProps={{htmlInput:{maxLength:250}}}
                sx={{marginTop: ".5rem"}} />
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>{Translate.get("Cancel")}</Button>
            <ButtonWithSpinner variant="contained" onClick={() => onInactivateClick({dataId: actorPermit.dataId, actorPermitId: actorPermit.actorPermitId, inactivationNote: reason})}>{Translate.get("Inactivate")}</ButtonWithSpinner>
        </DialogActions>
    </Dialog>
)};
export default InactivateActorPermitDialog;